import { AxiosError } from 'axios';
import { Translator } from '@/types/translator.type';

/**
 * Error toast for a circuit save. The save is refused when a benefit of the
 * form was moved to the trash after the form was opened.
 */
export const saveCircuitErrorToast = (t: Translator) => ({
  render: ({ data }: { data: unknown }) => {
    if (data instanceof AxiosError) {
      const body = data.response?.data as
        | { code?: string; benefitCodes?: string[] }
        | undefined;
      if (body?.code === 'CIRCUIT_BENEFITS_IN_TRASH') {
        return t('circuits.benefitsInTrash', {
          codes: (body.benefitCodes ?? []).join(', '),
        });
      }
    }
    return t('common.errorOccurred');
  },
});
